/**
 * Injects date timestamps into drawing objects for persistence.
 * When drawings are saved, we store both the index (for runtime) and the date (for persistence).
 * This allows drawings to maintain their position even when new bars are added to the chart.
 *
 * Extraido de useInteractiveObjects.jsx para permitir teste unitario puro (anti-drift #104).
 *
 * @param {Object} item - The drawing object (trendline, fibonacci, etc.)
 * @param {Array} chartData - The chart data array with idx.date information
 * @returns {Object} - The drawing object with date fields added
 */
export const injectDatesIntoDrawing = (item, chartData) => {
  if (!chartData?.length || !item) return item;

  const result = { ...item };

  // Helper to get date timestamp from an x index
  const getDateFromIndex = (xIndex) => {
    if (xIndex === undefined || xIndex === null) return null;
    // Find the bar with matching index
    const bar = chartData.find((d) => d.idx?.index === xIndex);
    if (bar) {
      return bar.idx?.date?.getTime() || bar.date?.getTime() || null;
    }
    return null;
  };

  // Handle start/end format (TrendLine, Segment, Line, Ray, Rectangle, Ellipse, etc.)
  if (Array.isArray(item.start) && item.start[0] !== undefined) {
    result.startDate = getDateFromIndex(item.start[0]);
  }
  if (Array.isArray(item.end) && item.end[0] !== undefined) {
    result.endDate = getDateFromIndex(item.end[0]);
  }

  // Handle x1/x2/x3 format (Fibonacci tools, channels, etc.)
  if (item.x1 !== undefined) result.x1Date = getDateFromIndex(item.x1);
  if (item.x2 !== undefined) result.x2Date = getDateFromIndex(item.x2);
  if (item.x3 !== undefined) result.x3Date = getDateFromIndex(item.x3);

  // Handle position format (InteractiveText, Callout)
  if (Array.isArray(item.position) && item.position[0] !== undefined) {
    result.positionDate = getDateFromIndex(item.position[0]);
  }

  // Handle yValue with xValue for VerticalLine
  if (item.xValue !== undefined) {
    result.xValueDate = getDateFromIndex(item.xValue);
  }

  return result;
};
